<div class="carousel">
  <div class="carousel__wrapper">
    <ng-content></ng-content>
  </div>
</div>
